<div class="button-loader-spinner">
  <div class="loader"><div class="ball-pulse"><div></div><div></div><div></div><span class="button-loading-message">{{ message }}</span></div></div>
</div>
